import { render, staticRenderFns } from "./TermTabs.vue?vue&type=template&id=4d0c4206"
import script from "./TermTabs.vue?vue&type=script&lang=js"
export * from "./TermTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports